import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@/hooks'
import { cn } from '@/lib/utils'
import { logout } from '@/slices/auth'

import {
	BoxIcon,
	CalendarAddIcon,
	CalendarIcon,
	FourBoxIcon,
	LogoImage,
	LogoutIcon,
	ProfilePhotoImage,
	ShoppingCartIcon,
	TaskSquareIcon,
	UserTickIcon,
} from '@/assets/icons'

export const customerTabs = [
	{ name: 'ÜBERSICHT', icon: FourBoxIcon, href: '/customer/overview' },
	{ name: 'MEINE BUCHUNGEN', icon: TaskSquareIcon, href: '/customer/bookings' },
	{ name: 'ARTIKEL', icon: BoxIcon, href: '/customer/products' },
	{ name: 'MINMINI SHOP', icon: ShoppingCartIcon, href: 'https://www.minmini-shop.de/' },
	{ name: 'REGAL MIETEN', icon: CalendarIcon, href: '/customer/regal-mieten' },
	{ name: 'BUCHUNG VERLÄNGERN', icon: CalendarAddIcon, href: '/customer/extend-booking' },
]

interface SidebarProps {
	isDialogOpen: boolean
	setIsDialogOpen: (value: boolean) => void
}

export const Sidebar = ({ isDialogOpen, setIsDialogOpen }: SidebarProps) => {
	const dispatch = useAppDispatch()
	const auth = useAppSelector(state => state.auth)

	return (
		<Dialog open={isDialogOpen} onClose={setIsDialogOpen} className="lg:hidden">
			<div className={cn('fixed inset-0 z-10', { 'bg-black/20': { isDialogOpen } })} />
			<DialogPanel className="fixed w-10/12 inset-y-0 left-0 z-10 overflow-y-auto bg-white px-6 py-10 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
				<div className="flex items-center justify-between">
					<div className="-m-1.5 p-1.5 flex items-center gap-2">
						<a href="/" className="-m-1.5 p-1.5">
							<span className="sr-only">Book Stands</span>
							<img src={LogoImage} className="h-8 w-auto shrink-0" />
						</a>
						<div className="flex flex-col w-3/5 flex-wrap gap-1">
							<h3 className="text-secondary font-extrabold">minmini</h3>
							<p className="text-[10px] font-medium text-muted-foreground">
								(Ver)kaufe nachhaltig, schaffe Platz und verdiene dabei.
							</p>
						</div>
					</div>
					<button
						type="button"
						onClick={() => setIsDialogOpen(false)}
						className="-m-2.5 rounded-md p-2.5 text-muted-foreground">
						<span className="sr-only">Close menu</span>
						<XMarkIcon aria-hidden="true" className="size-6" />
					</button>
				</div>
				<div className="mt-3 h-px w-full bg-[#0B224D0D]" />
				<div className="mt-4 flex items-center gap-2">
					<img src={ProfilePhotoImage} className="size-6 rounded-full" />
					<div className="flex flex-col gap-1">
						<h2 className="text-secondary text-xs font-extrabold">
							{auth.first_name} {auth.last_name}
						</h2>
						<p className="text-muted-foreground text-[10px]">{auth.email}</p>
					</div>
				</div>
				<div className="mt-8 flow-root">
					<h4 className="uppercase text-xs text-muted-foreground">Menu</h4>
					<div className="space-y-3 pt-3">
						{customerTabs.map(tab => (
							<NavLink
								key={tab.name}
								to={tab.href}
								onClick={() => {
									if (tab.name === 'REGAL MIETEN') {
										window.location.href = '/customer/regal-mieten'
									}
								}}
								className={({ isActive }) =>
									cn(
										'flex items-center cursor-pointer gap-1 text-xs font-medium rounded-lg px-4 py-[13px]',
										isActive ? 'text-white bg-secondary' : 'text-muted-foreground',
									)
								}>
								<tab.icon />
								{tab.name}
							</NavLink>
						))}
					</div>
					<div
						onClick={() => dispatch(logout())}
						className="flex cursor-pointer items-center mt-10 uppercase gap-1 rounded-lg px-4 py-[13px] text-xs font-medium text-muted-foreground hover:bg-secondary hover:text-white">
						<LogoutIcon />
						Logout
					</div>
					<NavLink
						to={'/customer/recruit'}
						className={({ isActive }) =>
							cn(
								'flex mt-3 cursor-pointer items-center uppercase gap-1 rounded-lg px-4 py-[13px] text-xs font-medium text-muted-foreground hover:bg-secondary hover:text-white',
								isActive ? 'text-white bg-secondary' : 'text-muted-foreground',
							)
						}>
						<UserTickIcon />
						FREUNDE WERBEN FREUNDE
					</NavLink>
				</div>
			</DialogPanel>
		</Dialog>
	)
}
